import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-126">
      <div className="max-w-2xl mx-auto text-center" data-id="element-127">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-128">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#FFD700] mb-4" data-id="element-129">
          GARANTÍA MEGAPACK MÚSICA — 7 DÍAS
        </h2>

        <div className="bg-[#0d0d00] border-2 border-[#FFD700] rounded-2xl p-8 mb-6" data-id="element-130">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-131">
            Abres los 12 tomos. Revisas los 6 bonos. Los usas en el aula si
            quieres.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-132">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#FFD700] text-3xl font-black mb-4" data-id="element-133">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-134">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed italic" data-id="element-135">
          La confianza que tenemos en el MegaPack Música nos permite ofrecerte
          eso. Desde México hasta España. Desde Guatemala hasta Chile. El mismo
          compromiso para todos.
        </p>
      </div>
    </section>;
}